module.exports = __webpack_public_path__ + "static/blueteddybathmain-699eacd1852745ac13096e173b64a1a3.jpeg";